export type Testimonial = {
  id: string;
  segment: string;
  image: string | null;
  imageAlt: string;
  objectFit?: "cover" | "contain";
  objectPosition?: string;
  business: string;
  owner: string;
  quote: string;
};

export const testimonials: Testimonial[] = [
  {
    id: "casa-de-carnes-filadelfia",
    segment: "Açougue",
    image: "/depoimentos/casa-de-carnes-filadelfia.jpg",
    imageAlt: "Foto do estabelecimento Casa de Carnes Filadélfia",
    business: "Casa de Carnes Filadélfia",
    objectPosition: "top",
    owner: "Juscelino Lima",
    quote:
      "O Verdana me ajudou a realizar minhas vendas com mais facilidade, calculando o valor total de cada venda e informando o troco ou o Pix quando necessário. Também me ajudou a controlar os fiados do meu negócio. E, por ser offline, nunca tive problemas para acessá-lo.",
  },
  {
    id: "bomboniere-da-albany",
    segment: "Bomboniere",
    image: "/depoimentos/bomboniere-da-albany.jpg",
    imageAlt: "Foto do estabelecimento Bomboniere da Albany",
    business: "Bomboniere da Albany",
    owner: "José Luiz",
    objectPosition: "top",
    quote:
      "Consegui salvar minhas vendas e despesas com facilidade. A parte de cálculo das taxas dos cartões tem me ajudado bastante, e a possibilidade de salvar atalhos para os produtos também torna as vendas muito mais ágeis.",
  },
];
